// extracted by mini-css-extract-plugin
module.exports = {"item":"i_Ig","link":"i_Ih"};